import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {ApiKey, dataUrl} from '../config'
import Spinner from './Spinner';
import Subscribe from './Subscribe';

import './PracticeMCQ.css'
/* Debug
const questions = [
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. Jhelum River passes through Wular Lake. </p><p>2. Krishna River directly feeds Kolleru Lake. </p><p>3. Meandering of Gandak River formed Kanwar Lake. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Kolleru lake is fed directly by water from the seasonal Budameru and Tammileru streams and lies between Krishna and Godavari rivers hence statement 2 is incorrect.<br>Statement 1 and 3 are factually correct.</p><p></p><p></p><p></p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture:<b>Consider the following information:</b></p><table border='1'><tr><td><div></div><p><b>Waterfall</b></p></td><td><div></div><p><b>Region</b></p></td><td><div></div><p><b>River</b></p></td></tr><tr><td><div></div><p>1. Dhuandhar</p></td><td><div></div><p>Malwa</p></td><td><div></div><p>Narmada</p></td></tr><tr><td><div></div><p>2. Hundru</p></td><td><div></div><p>Chota Nagpur</p></td><td><div></div><p>Subarnarekha</p></td></tr><tr><td><div></div><p>3. Gersoppa</p></td><td><div></div><p>Western Ghats</p></td><td><div></div><p>Netravati</p></td></tr></table><p>In how many of the above rows is the given information correctly matched?</p><p></p><p></p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p><b>Explanation:</b></p><ul><li><b>Dhuandhar Falls</b> is correctly associated with the <b>Narmada River</b> but is located in <b>Madhya Pradesh</b>, not Malwa.</li></ul><ul><li><b>Hundru Falls</b> is correctly associated with <b>Chota Nagpur Plateau</b> and <b>Subarnarekha River</b>.</li></ul><ul><li><b>Gersoppa Falls</b> (Jog Falls) is on the <b>Sharavati River</b>, not Netravati.</li></ul><p>Thus, only two matches are correct.</p><p></p><p></p><p></p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The President of India can pardon a death sentence. </p><p>2. The Governor of a state can suspend a life imprisonment sentence. </p><p>3. The Supreme Court of India cannot review its own judgments. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The President has the power to pardon a death sentence under Article 72. Statement 2 is correct: The Governor can suspend a life sentence under Article 161. Statement 3 is incorrect: The Supreme Court can review its own judgments under Article 137.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. The Ganges River originates from the Gangotri Glacier. </p><p>2. The Brahmaputra River flows through Kerala before entering Bangladesh. </p><p>3. The Indus River system supports the Thar Desert. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Ganges originates from the Gangotri Glacier. Statement 2 is incorrect: The Brahmaputra flows through Assam, not Kerala. Statement 3 is incorrect: The Indus River does not support the Thar Desert; it flows west of it.</p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Indian Constitution was adopted on January 26, 1950. </p><p>2. The President of India is elected by an electoral college. </p><p>3. The Prime Minister must be a member of the Rajya Sabha. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is incorrect: The Constitution was adopted on November 26, 1949, and came into effect on January 26, 1950. Statement 2 is correct: The President is elected by an electoral college. Statement 3 is incorrect: The Prime Minister can be a member of either the Lok Sabha or Rajya Sabha.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. Jhelum River passes through Wular Lake. </p><p>2. Krishna River directly feeds Kolleru Lake. </p><p>3. Meandering of Gandak River formed Kanwar Lake. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Kolleru lake is fed directly by water from the seasonal Budameru and Tammileru streams and lies between Krishna and Godavari rivers hence statement 2 is incorrect.<br>Statement 1 and 3 are factually correct.</p><p></p><p></p><p></p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture:<b>Consider the following information:</b></p><table border='1'><tr><td><div></div><p><b>Festival</b></p></td><td><div></div><p><b>State</b></p></td></tr><tr><td><div></div><p>1. Onam</p></td><td><div></div><p>Kerala</p></td></tr><tr><td><div></div><p>2. Bihu</p></td><td><div></div><p>Assam</p></td></tr><tr><td><div></div><p>3. Pongal</p></td><td><div></div><p>Gujarat</p></td></tr></table><p>In how many of the above rows is the given information correctly matched?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Onam is correctly matched with Kerala, and Bihu is correctly matched with Assam. Pongal is incorrectly matched with Gujarat; it is celebrated in Tamil Nadu.</p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Lok Sabha can be dissolved by the President. </p><p>2. The Rajya Sabha is a permanent body. </p><p>3. The Vice President presides over the Lok Sabha. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The President can dissolve the Lok Sabha. Statement 2 is correct: The Rajya Sabha is a permanent body. Statement 3 is incorrect: The Vice President presides over the Rajya Sabha, not the Lok Sabha.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. The Yamuna River is a tributary of the Ganges. </p><p>2. The Godavari River is the longest river in India. </p><p>3. The Narmada River flows eastward into the Bay of Bengal. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Yamuna is a tributary of the Ganges. Statement 2 is incorrect: The Ganges is longer than the Godavari. Statement 3 is incorrect: The Narmada flows westward into the Arabian Sea.</p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Constitution of India provides for a federal structure. </p><p>2. The Union List contains subjects like defense and foreign affairs. </p><p>3. The State List includes subjects like railways and banking. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: India has a federal structure. Statement 2 is correct: The Union List includes defense and foreign affairs. Statement 3 is incorrect: Railways and banking are in the Union List, not the State List.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture:<b>Consider the following information:</b></p><table border='1'><tr><td><div></div><p><b>Monument</b></p></td><td><div></div><p><b>Location</b></p></td></tr><tr><td><div></div><p>1. Taj Mahal</p></td><td><div></div><p>Agra</p></td></tr><tr><td><div></div><p>2. Qutub Minar</p></td><td><div></div><p>Mumbai</p></td></tr><tr><td><div></div><p>3. Red Fort</p></td><td><div></div><p>Delhi</p></td></tr></table><p>In how many of the above rows is the given information correctly matched?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Taj Mahal is correctly matched with Agra, and Red Fort is correctly matched with Delhi. Qutub Minar is incorrectly matched with Mumbai; it is in Delhi.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. Jhelum River passes through Wular Lake. </p><p>2. Krishna River directly feeds Kolleru Lake. </p><p>3. Meandering of Gandak River formed Kanwar Lake. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Kolleru lake is fed directly by water from the seasonal Budameru and Tammileru streams and lies between Krishna and Godavari rivers hence statement 2 is incorrect.<br>Statement 1 and 3 are factually correct.</p><p></p><p></p><p></p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Finance Commission is a constitutional body. </p><p>2. The Election Commission is responsible for conducting local elections. </p><p>3. The Planning Commission was replaced by NITI Aayog. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Finance Commission is established under Article 280. Statement 2 is incorrect: The Election Commission conducts national and state elections, not local ones (handled by State Election Commissions). Statement 3 is correct: NITI Aayog replaced the Planning Commission in 2015.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture:<b>Consider the following information:</b></p><table border='1'><tr><td><div></div><p><b>Dance Form</b></p></td><td><div></div><p><b>State</b></p></td></tr><tr><td><div></div><p>1. Kathakali</p></td><td><div></div><p>Kerala</p></td></tr><tr><td><div></div><p>2. Bharatanatyam</p></td><td><div></div><p>Tamil Nadu</p></td></tr><tr><td><div></div><p>3. Garba</p></td><td><div></div><p>Punjab</p></td></tr></table><p>In how many of the above rows is the given information correctly matched?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Kathakali is correctly matched with Kerala, and Bharatanatyam is correctly matched with Tamil Nadu. Garba is incorrectly matched with Punjab; it is from Gujarat.</p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Chief Justice of India is appointed by the President. </p><p>2. The Attorney General of India is a member of the Cabinet. </p><p>3. The Comptroller and Auditor General audits the accounts of the Union and States. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Chief Justice is appointed by the President. Statement 2 is incorrect: The Attorney General is not a member of the Cabinet. Statement 3 is correct: The CAG audits Union and State accounts.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. The Kaveri River originates in the Western Ghats. </p><p>2. The Sutlej River is a tributary of the Ganges. </p><p>3. The Mahanadi River flows into the Arabian Sea. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Kaveri originates in the Western Ghats. Statement 2 is incorrect: The Sutlej is a tributary of the Indus, not the Ganges. Statement 3 is incorrect: The Mahanadi flows into the Bay of Bengal.</p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Constitution of India was drafted by the Constituent Assembly. </p><p>2. The Fundamental Rights are non-justiciable. </p><p>3. The Directive Principles of State Policy are enforceable by law. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Constituent Assembly drafted the Constitution. Statement 2 is incorrect: Fundamental Rights are justiciable. Statement 3 is incorrect: Directive Principles are not enforceable by law.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture:<b>Consider the following information:</b></p><table border='1'><tr><td><div></div><p><b>River</b></p></td><td><div></div><p><b>Origin</b></p></td></tr><tr><td><div></div><p>1. Ganges</p></td><td><div></div><p>Gangotri Glacier</p></td></tr><tr><td><div></div><p>2. Brahmaputra</p></td><td><div></div><p>Himalayas</p></td></tr><tr><td><div></div><p>3. Krishna</p></td><td><div></div><p>Eastern Ghats</p></td></tr></table><p>In how many of the above rows is the given information correctly matched?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Ganges is correctly matched with Gangotri Glacier, and Brahmaputra is correctly matched with the Himalayas. Krishna is incorrectly matched with Eastern Ghats; it originates in the Western Ghats.</p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Parliament of India consists of the Lok Sabha and Rajya Sabha only. </p><p>2. The President of India is part of the Parliament. </p><p>3. Money Bills can be introduced only in the Lok Sabha. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is incorrect: The Parliament includes the President along with the Lok Sabha and Rajya Sabha. Statement 2 is correct: The President is part of the Parliament. Statement 3 is correct: Money Bills can only be introduced in the Lok Sabha.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. The Chilika Lake is located in Odisha. </p><p>2. The Sambhar Lake is a freshwater lake. </p><p>3. The Loktak Lake is known for its floating islands. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: Chilika Lake is in Odisha. Statement 2 is incorrect: Sambhar Lake is a saltwater lake. Statement 3 is correct: Loktak Lake in Manipur is known for its floating islands (phumdis).</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture:<b>Consider the following information:</b></p><table border='1'><tr><td><div></div><p><b>Waterfall</b></p></td><td><div></div><p><b>Region</b></p></td><td><div></div><p><b>River</b></p></td></tr><tr><td><div></div><p>1. Dhuandhar</p></td><td><div></div><p>Malwa</p></td><td><div></div><p>Narmada</p></td></tr><tr><td><div></div><p>2. Hundru</p></td><td><div></div><p>Chota Nagpur</p></td><td><div></div><p>Subarnarekha</p></td></tr><tr><td><div></div><p>3. Gersoppa</p></td><td><div></div><p>Western Ghats</p></td><td><div></div><p>Netravati</p></td></tr></table><p>In how many of the above rows is the given information correctly matched?</p><p></p><p></p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p><b>Explanation:</b></p><ul><li><b>Dhuandhar Falls</b> is correctly associated with the <b>Narmada River</b> but is located in <b>Madhya Pradesh</b>, not Malwa.</li></ul><ul><li><b>Hundru Falls</b> is correctly associated with <b>Chota Nagpur Plateau</b> and <b>Subarnarekha River</b>.</li></ul><ul><li><b>Gersoppa Falls</b> (Jog Falls) is on the <b>Sharavati River</b>, not Netravati.</li></ul><p>Thus, only two matches are correct.</p><p></p><p></p><p></p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Governor of a state is appointed by the President. </p><p>2. The Chief Minister is appointed by the Prime Minister. </p><p>3. The High Court judges are appointed by the Governor. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "a",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Governor is appointed by the President. Statement 2 is incorrect: The Chief Minister is appointed by the Governor, not the Prime Minister. Statement 3 is incorrect: High Court judges are appointed by the President.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture: Consider the following statements : </p><p>1. The Sabarmati River flows through Ahmedabad. </p><p>2. The Tapti River originates in the Eastern Ghats. </p><p>3. The Periyar River is the longest river in Kerala. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The Sabarmati flows through Ahmedabad. Statement 2 is incorrect: The Tapti originates in the Satpura Range, not the Eastern Ghats. Statement 3 is correct: The Periyar is the longest river in Kerala.</p></td>"
      },
      {
          "subject": "polity",
          "Question": "<div></div><td><div></div><p>Consider the following statements : </p><p>1. The Union Public Service Commission conducts examinations for civil services. </p><p>2. The National Human Rights Commission is a statutory body. </p><p>3. The Law Commission of India is a constitutional body. </p><p>How many of the statements given above are correct?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Statement 1 is correct: The UPSC conducts civil service exams. Statement 2 is correct: The NHRC is a statutory body under the Protection of Human Rights Act, 1993. Statement 3 is incorrect: The Law Commission is not a constitutional body; it is an executive body.</p></td>"
      },
      {
          "subject": "culture",
          "Question": "<div></div><td><div></div><p>culture:<b>Consider the following information:</b></p><table border='1'><tr><td><div></div><p><b>Lake</b></p></td><td><div></div><p><b>State</b></p></td></tr><tr><td><div></div><p>1. Wular Lake</p></td><td><div></div><p>Jammu & Kashmir</p></td></tr><tr><td><div></div><p>2. Kolleru Lake</p></td><td><div></div><p>Andhra Pradesh</p></td></tr><tr><td><div></div><p>3. Chilika Lake</p></td><td><div></div><p>Kerala</p></td></tr></table><p>In how many of the above rows is the given information correctly matched?</p></td>",
          "A": "Only one",
          "B": "Only two",
          "C": "All three",
          "D": "None",
          "E": null,
          "F": null,
          "Answer": "b",
          "Explanation": "<div></div><td><div></div><p>Wular Lake is correctly matched with Jammu & Kashmir, and Kolleru Lake is correctly matched with Andhra Pradesh. Chilika Lake is incorrectly matched with Kerala; it is in Odisha.</p></td>"
      }
  ];
*/
const PracticeQuiz = ({ subject, MCQsubjects, backToLogin }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showExplanation, setShowExplanation] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isModuleCompleted, setIsModuleCompleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New loading state
  const [questions, setquestions] = useState([]);
  const [SubscribeMsg, setSubscribeMsg] = useState(null);
  
const fetchPracticeQuestions = () => {
  setIsLoading(true);
  var req = {
    email: localStorage.getItem('user'),
    method: "GetPracticeMCQs",
    subject: subject,
    params: {
      subjectsList: MCQsubjects.join(",")
    }
  };
  const headers = { 
    'x-api-key': ApiKey
  };
  axios.post( dataUrl, req, { withCredentials: true, headers:headers}).then(resp=>{

//axios.post('http://localhost:3004', req).then(resp=>{
const base64Content = resp.data;
// Decode base64 and parse JSON
let parsedContent;
try {
  const binaryString = atob(base64Content);
  const utf8Decoder = new TextDecoder('utf-8'); // Create a UTF-8 decoder
  const jsonString = utf8Decoder.decode(Uint8Array.from(binaryString, char => char.charCodeAt(0)));
  parsedContent = JSON.parse(jsonString);
  let bodystr = parsedContent.body;
  if (typeof bodystr === "string") {
    bodystr = JSON.parse(bodystr); 
    if (bodystr?.message === "Finished all of the module") {
        setquestions([]);
        setIsModuleCompleted(true);
        }
    else if(bodystr?.message === "Your subscription not valid. Please subscribe to get the Practice Questions")
      setSubscribeMsg(bodystr.message);
      setquestions([]);
      setIsModuleCompleted(false);
  } else if (Array.isArray(parsedContent)) {
    setquestions(parsedContent);
    setCurrentQuestionIndex(0);
    setSelectedAnswer(null);
    setShowExplanation(false);
    setTimeLeft(60);
    setIsModuleCompleted(false);
  }
} catch (e) {
  console.log("Error decoding or parsing content:", e);
  setIsModuleCompleted(true);
  return; // Exit if decoding/parsing fails
}
}).catch(err => {console.log(err);})
.finally(() => {
  setIsLoading(false); // Stop loading when done (success or error)
});
}
  useEffect( () => {
    fetchPracticeQuestions();
  },[MCQsubjects]);


  useEffect(() => {
    if (timeLeft > 0 && !showExplanation) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } 
  }, [timeLeft, showExplanation]);

  const handleAnswerClick = (answer) => {
    setSelectedAnswer(answer);
    setShowExplanation(true);

    };

  const handleNextQuestion = () => {
    setCurrentQuestionIndex(currentQuestionIndex + 1);
    setSelectedAnswer(null);
    setShowExplanation(false);
    setTimeLeft(60);
  };
  // todo:: multiple correct answers  handling


  return (
    <div>
    { isLoading && <Spinner wholepage={true} />}
    { questions.length > 0 && 
      <>
    <div className="quiz-container">
      <div className="left-column">
      <div className="timer">Time Left: {timeLeft} seconds</div>
      <div className="question"  dangerouslySetInnerHTML={{ __html: questions[currentQuestionIndex]?.Question}}></div>
      <div className="options">
        {['A', 'B', 'C', 'D'].map((option) => (
          <button
            key={option}
            className={`option-button 
              ${selectedAnswer === option ? 'selected' : ''} 
              ${selectedAnswer && option === questions[currentQuestionIndex]?.Answer.toUpperCase() ? 'correct' : ''}
              ${selectedAnswer && option !== questions[currentQuestionIndex]?.Answer.toUpperCase() && selectedAnswer === option ? 'incorrect' : ''}`}
            onClick={() => handleAnswerClick(option)}
            disabled={showExplanation}
          >
            <div className='flex items-center'>
              <div className='w-8 text-left'>
            {option+") "}
            </div>
            <div className='flex-1 text-center'>{questions[currentQuestionIndex]?.[option]}</div>
            </div>
          </button>
        ))}
      </div>
      </div>
      {selectedAnswer && !isModuleCompleted && ( <div className="right-column">
        <div className="explanationsection">
          <p>{selectedAnswer === questions[currentQuestionIndex]?.Answer.toUpperCase() ? 'Correct!' : 'Wrong!'}</p>
          <div className="explanation"  dangerouslySetInnerHTML={{ __html: questions[currentQuestionIndex]?.Explanation}}></div>
          <p>Correct Answer: {questions[currentQuestionIndex]?.Answer.toUpperCase()}</p>
          {!(currentQuestionIndex === questions.length - 1) && (
            <button className='NextQuestion' onClick={handleNextQuestion}>Next Question</button>
          )}
          {(currentQuestionIndex === questions.length - 1) && showExplanation && !isModuleCompleted && (
            <button className='NextQuestion' onClick={() =>fetchPracticeQuestions()}>
              Keep Going!!
            </button>
          )}
        </div>
      </div>)}
      

    </div>
    </>}

  {SubscribeMsg  && <Subscribe msg={SubscribeMsg} backToLogin={backToLogin}/>}
  {isModuleCompleted && (
    <div className="module-complete">
      <h2>{MCQsubjects.join(",") + " Completed!"}</h2>
      <button className='NextQuestion' onClick={() =>fetchPracticeQuestions()}>
        Redo module
      </button>
    </div>
  )}
</div>
  );
};

export default PracticeQuiz;